import { render, staticRenderFns } from "./ExitToApp.vue?vue&type=template&id=4a4755ca&functional=true&"
import script from "./ExitToApp.vue?vue&type=script&lang=js&"
export * from "./ExitToApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports